const ApiResolvers = require('@/lib/Api/ApiResolvers');
const ApiResponseUnmapper = require('../libraries/DigiTickets/Api/ApiResponseUnmapper');

/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 * @param {UserService} userService
 * @return {*}
 * @constructor
 */
const MembershipPlanResource = function (
    $resource,
    apiRequestParams,
    appConfig,
    userService
) {
    return $resource(
        appConfig.apiBaseUrl + 'membershipplans/',
        Object.assign(
            apiRequestParams.defaults(),
            {
                branchID: () => userService.getItemBranchID(),
                channelID: appConfig.channelID,
                resolve: [
                    '*',
                    'membershipPlans.paymentDescription',
                    ApiResolvers.ITEM_BARCODES,
                ].join(','),
            }
        ),
        {
            query: {
                isArray: true,
                params: Object.assign(
                    {
                        excludeFields: apiRequestParams.defaultExcludeFields(),
                    },
                    apiRequestParams.defaultMappers()
                ),
                transformResponse: (json) => ApiResponseUnmapper.transformApiResponse(json, 'MembershipPlan'),
            },
        }
    );
};

module.exports = MembershipPlanResource;
